import { connection } from "@/api/connection";

const controllerRoot = "portal/system";
export default {
  async getSystemSettings() {
    return await connection.get(controllerRoot);
  }
};
